<h1>Forgotten Password</h1>

<div>
    Username or Email:
    <input placeholder="johnsmith@example.com" [(ngModel)]="model.user"/>
</div>

<p class="err-text" *ngIf="show_error">{{error_text}}</p>

<div class="flex-row-container" style="align-items: stretch; padding-top: 10px;">
    <div class="flex-col-container" style="justify-content: center;">
        <a href="/sign-in" style="display: block;" [className]="is_loading ? 'disabled-link' : ''">Back</a>
    </div>
    <div class="flex-grow"></div>
    <button class="flat-button" (click)="resetPressed()" [disabled]="is_loading">Request Reset</button>
</div>